import React from "react"

import ContentLoaderTags from "./ContentLoaderTags"

export default props => <ContentLoaderTags isFetching={true} {...props} />
